export const tokens = {
    gap: 12,
    padding: {
        x: 8,
    },
    height: 56,
    action: {
        gap: 8,
        minWidth: 80,
        height: 40,
        iconSize: 16,
        valueSize: 17,
    },
};
